// extracted by mini-css-extract-plugin
module.exports = {"container":"add-payment-card_container__2_DJ9","addIcon":"add-payment-card_addIcon__3UDJt"};